<template>
  <div>
    <div class="mx-5">
      <div class="finance-options my-4 mx-3">Finance Options</div>
      <span class="ml-3">Here you will be able to select or add additional lenders from our approved lender network. TD Retail Card Services will always be the prime lending solution.</span>
      <span v-if="isAvbProgram()">For sub-prime lending, we have a preferred lender relationship with Snap Finance.</span>
    </div>

    <v-layout row wrap>
      <v-spacer/>
      <v-flex>
        <LenderSelectionItem tier="PRIME" :lender="selectedLenderByTier['PRIME']"/>
      </v-flex>

      <v-flex v-if="allLendersByTier['NEAR_PRIME'].length > 0 && !nearPrimeDevalued">
        <v-spacer/>
        <LenderSelectionItem tier="NEAR_PRIME"
                             :lender="selectedLenderByTier['NEAR_PRIME']"
                             @editLender="onEditLender('NEAR_PRIME')"/>
      </v-flex>

      <v-flex v-if="allLendersByTier['LEASE'].length > 0">
        <v-spacer/>
        <LenderSelectionItem tier="LEASE"
                             :lender="selectedLenderByTier['LEASE']"
                             @editLender="onEditLender('LEASE')"/>
      </v-flex>

      <v-spacer/>
    </v-layout>

    <v-layout row wrap class="btn-wrapper">
      <v-dialog
        v-model="singleLenderDialogVisible"
        @keydown.esc="singleLenderDialogVisible = false"
        persistent
        max-width="600px"
      >
        <v-card class="single-provider">
          <v-card-title>
              Single Provider Selected
          </v-card-title>
          <v-card-text>
            No 'Near-Prime' or 'Sub-Prime' lenders were selected. Adding other lenders increases the chances of customer approval.
            <div class="note">Note: 'Near-Prime' and 'Sub-Prime' lenders can be added/removed later.</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat class="btn-primary" @click.native="singleLenderDialogVisible = false">
              Return to provider selection
            </v-btn>
            <v-btn flat class="btn-secondary mx-1" @click="returnToApplication(true)">
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>


    <v-card class="mx-auto my-5 lender-card" min-width="1000" max-width="1000"
            v-if="allLendersByTier['NEAR_PRIME'].length > 0 && nearPrimeDevalued">
      <v-card-title class="NEAR_PRIME-tier title white--text py-0 px-6">
        <div class="tier-text">
          {{ $t('message.lenderTierName.NEAR_PRIME') }}
        </div>
      </v-card-title>

      <v-container grid-list-md>
        <v-layout col>
          <v-flex v-for="lender in allLendersByTier['NEAR_PRIME']"
                  class="drawer-item ma-2"
                  @click="selectDevaluedLender(lender)"
                  :key=lender.bankId>

            <SelectableLender :lender="lender" :selected="lender.bankId === selectedLender.bankId"/>
          </v-flex>
        </v-layout>

        <h3 class="my-3">None Selected</h3>

        <div>Though not required, AVB Complete does allow for the option for a near-prime lender. Click to choose the lender.</div>

      </v-container>

    </v-card>

    <footer>
      <div class="footer-save">
        <div class="buttons">
          <button @click="returnToApplication(false)" class="footer-save_btn">Continue</button>
        </div>
      </div>
    </footer>

    <v-navigation-drawer v-model="showDrawer" absolute temporary right width="400">
      <v-container grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 v-for="lender in drawerLenders"
                       class="drawer-item ma-2"
                       @click="selectDrawerLender(lender)"
                       :key=lender.bankId>
            <SelectableLender :lender="lender" :selected="lender.bankId === selectedLender.bankId"/>
          </v-flex>
        </v-layout>

        <v-btn class="btn-primary" @click=closeAndSaveLenders() :disabled="!selectedLender">
          Save Changes
        </v-btn>

      </v-container>
    </v-navigation-drawer>


    <v-dialog v-model="selectedDevaluedLenderConfirm" persistent max-width="320px">
      <v-card>
        <v-card-title>
          <h3>Selecting Near Prime</h3>
        </v-card-title>
        <v-card-text>
          Are you sure you want to select near prime?
        </v-card-text>
        <v-flex>
          <SelectableLender :lender="selectedLender" :selected="true"/>
        </v-flex>

        <v-card-actions>
          <v-spacer/>
          <v-btn flat class="btn-secondary" @click="confirmSelectDevaluedLender">
            Sure, Go ahead
          </v-btn>
          <v-btn flat class="btn-primary" @click="cancelSelectDevaluedLender">
            Not Now
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import axiosMixin from '@/mixins/axiosMethods'
import {axiosAuthInstance} from '../../main.js'
import LenderSelectionItem from '@/components/Application/LenderSelectionItem.vue'
import SelectableLender from '@/components/Application/SelectableLender.vue'

const unselectedLender = {
  "name" : "None Selected",
  "bankId" : "unselected"
}

export default {
  props: {
    label: {
      type: Object
    }
  },
  data() {
    return {
      dealerApp: null,
      singleLenderDialogVisible: false,
      //for AVB, we don't initially show the NEAR-PRIME LenderSelectionItem. Instead, a separate component will be shown below
      //the LenderSelectionItem list. This is all being done for marketing purposes - they want to not only prefer Snap as a SUB-PRIME,
      //but also prefer to NOT have a NEAR-PRIME. However, if a NEAR-PRIME has been selected, then the
      //LenderSelectionItem behaves the same as SUB-PRIME.
      allLendersByTier: { //all lenders available, by tier (tier -> lender list)
        'PRIME':[], 'NEAR_PRIME':[], 'LEASE':[]
      },
      selectedLenderByTier: {  //lender selected per tier (tier -> lender)
        'PRIME':unselectedLender, 'NEAR_PRIME':unselectedLender, 'LEASE':unselectedLender
      },
      drawerLenders: null,
      editLenderTier: null,
      lenderTiers: ['PRIME','NEAR_PRIME','LEASE'],
      selectedLender: unselectedLender,
      showDrawer: false,
      selectedDevaluedLenderConfirm: false
    }
  },
  mixins: [axiosMixin],
  components: {
    LenderSelectionItem, SelectableLender
  },
  computed: {
    //if AVB and no near primes selected, "devalue" them to the component below the main lender list
    nearPrimeDevalued() {
      if (this.isAvbProgram() && this.selectedLenderByTier['NEAR_PRIME'].bankId === 'unselected') {
        return true
      }
      return false
    }
  },
  methods: {
    isAvbProgram() {
      return (this.$store.getters.isAvb)
    },
    getLenderNote(lender) {
      if (lender.blacklistStates && lender.blacklistStates.length > 0) {
        return 'Currently unavailable in ' + this.joinWithAnd(lender.blacklistStates)
      }

      return ""
    },

    onEditLender(tier) {
      //show the drawer with the lenders applicable to the tier
      this.drawerLenders = this.allLendersByTier[tier] || []
      this.showDrawer = true
      this.editLenderTier = tier

      const lender = this.dealerAppLenderForTier(tier) || {}
      if (lender) {
        this.selectedLender = Object.assign({},lender)
      } else {
        this.selectedLender = unselectedLender
      }
    },

    closeAndSaveLenders() {
      this.drawerLenders = null
      this.showDrawer = false
      this.saveLenders()
    },

    selectDrawerLender(lender) {
      if (lender.bankId === this.selectedLender.bankId) {
        this.selectedLender = unselectedLender
      } else {
        this.selectedLender = Object.assign({},lender)
      }
    },

    selectDevaluedLender(lender) {
      this.selectedLender = Object.assign({},lender)
      this.selectedDevaluedLenderConfirm = true
      this.editLenderTier = 'NEAR_PRIME'
    },

    confirmSelectDevaluedLender() {
      Vue.set(this.selectedLenderByTier, this.editLenderTier, this.selectedLender)
      this.selectedDevaluedLenderConfirm = false
      this.saveLenders()
    },

    cancelSelectDevaluedLender() {
      this.selectedLender = unselectedLender
      this.selectedDevaluedLenderConfirm = false
    },

    returnToApplication(forceReturn) {
      if(this.$route.query && this.$route.query.isNewApp && this.dealerApp.lenders.length === 1 && !forceReturn) {
        this.singleLenderDialogVisible = true
      } else {
        this.$router.push('/application')
      }
    },

    saveLenders() {
      const lenders = []
      this.lenderTiers.forEach(tier => {
        //update the tier we just edited in the drawer
        if (tier === this.editLenderTier) {
          if (this.selectedLender.bankId != 'unselected') {
            lenders.push(this.selectedLender)
          }
        } else {
          //otherwise copy any existing lenders
          const lender = this.dealerAppLenderForTier(tier)
          if (lender) {
            lenders.push(lender)
          }
        }
      })

      this.dealerApp.lenders = [...lenders]

      axiosAuthInstance
        .post('api/v1/dealerApp/updateLenders', this.dealerApp)
        .then(response => {
          this.$store.getters.getDealerApplication.lenders = this.dealerApp.lenders;

          //update the main view from the drawer
          Vue.set(this.selectedLenderByTier, this.editLenderTier, this.selectedLender)
          this.selectedLender = unselectedLender
        })
        .catch(error => {
          this.notifyAxiosError(
            error, 'There was an error updating the application lenders'
          )
        })
    },

    loadLenders() {
      axiosAuthInstance.get('api/v1/dealerApp/get/' + this.$store.getters.getApplicationId)
        .then(response => {
          this.dealerApp = response.data

          this.fetchAvailableLenders(this.dealerApp.exclusiveBankId).then(response => {

            this.$store.getters.getAvailableLenders.forEach(availableLender => {
              this.allLendersByTier[availableLender.lenderTier].push(availableLender)

              const selectedLender = this.dealerAppLenderForBankId(availableLender.bankId)
              if (selectedLender) {
                Vue.set(this.selectedLenderByTier, selectedLender.lenderTier, selectedLender)
              }
            })
          })
        })
    },
    dealerAppLenderForBankId(bankId) {
      return this.dealerApp.lenders.find(o => o.bankId === bankId)
    },
    dealerAppLenderForTier(tier) {
      return this.dealerApp.lenders.find(o => o.lenderTier === tier)
    },
  },
  created() {
    this.loadLenders()
  }
}
</script>

<style lang="scss" scoped>

.drawer-item {
  border: 1px solid hsl(209, 23%, 60%) !important;
  border-radius: 5px;
}

.NEAR_PRIME-tier {
  background-color: rgb(137,191,69);
}

.lender-card {
  border-radius: 8px;
}
.title {
  min-height: 48px;
}
.tier-text {
  font-size: 1.2rem;
}
.lender-name {
  font-size: 1.5rem;
}

.finance-options {
  font-weight: bold;
  font-size: 1.5rem;
}

.footer-save {
  padding: 4rem;
}

.footer-save_btn {
  font-size: 1.5rem;
  text-decoration: none;
  width: 14rem;
  color: hsl(210, 22%, 49%);
  background: hsl(210, 31%, 80%);
  border: none;
  box-shadow: 0px 20px 30px -16px rgba(199, 199, 199, 1);
  transition: all 0.2s ease-out;
}

.footer-save_btn:hover {
  color: hsl(210, 31%, 80%);
  background: hsl(209, 23%, 60%);
  box-shadow: 0px 10px 30px -16px rgba(199, 199, 199, 1);
}

.preferred{
  background-color: rgb(96,0,157);
  border: 1px solid hsl(209, 23%, 60%) !important;
  border-radius: 10px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Application/LenderSelectionList.vue